export type NotificationType = 'success' | 'error' | 'info' | 'warning';

export interface Notification {
  id: string;
  type: NotificationType;
  message: string;
  duration?: number;   // ms, default 4000; 0 = persist until dismissed
}

export enum NotificationActionTypes {
  PUSH    = '@@notification/PUSH',
  DISMISS = '@@notification/DISMISS',
  CLEAR   = '@@notification/CLEAR',
}

export interface NotificationState {
  items: Notification[];
}
